import { native } from '@forest/native-services'
import {
  failureCause,
  nativeErrorCause,
  type ServiceLevelStatus,
  type SubscriptionServiceLevelStatus,
} from '@forest/paywall-core'
import type { Loaded } from '~/lib/loaded'

/** The subscription record on a service level, expired or not. */
type SubscriptionRecord = SubscriptionServiceLevelStatus['subscription']

export function subscriptionRecord(
  status: ServiceLevelStatus,
): SubscriptionRecord | null {
  return ('subscription' in status && status.subscription) || null
}

/**
 * Reads the service level through native (≥ 5.27.0; older apps report
 * `unsupported`), or why it could not.
 */
export async function loadServiceLevel(): Promise<Loaded<ServiceLevelStatus>> {
  try {
    const result = await native.user.getServiceLevel()
    return result.success
      ? { ok: true, value: result.data }
      : { ok: false, cause: nativeErrorCause(result.error) }
  } catch (error) {
    return { ok: false, cause: failureCause(error) }
  }
}
